import React from "react"
import clsx from "clsx"

import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import Img from "./Img"

import * as styles from "./banner.module.scss"
import { useObserver } from "../../../hooks/useObserver"
import GetFriendName from "./GetFriendName"
import {
  handleClickBanner,
  handleClickStickyBtn,
} from "../../../helpers/WatcherDL/utils/handleClickBanner"

type BannerProps = {
  buttonText?: string
  orderNum?: string
}

export function Banner({ buttonText = "Оформить карту", orderNum }: BannerProps) {
  const isVisible = useObserver(["app", "calculatorCard", "reviewCard", "formPkw", "lowerBanner"])

  return (
    <>
      <section className={styles.section} data-exclude={orderNum}>
        <Container className={styles.container}>
          <div className={styles.secondContainer}>
            <Img alt="bg image" className={styles.img} />
            <div className={styles.text}>
              <GetFriendName />
              <div>
                За оформление начислим <br className="d-sm-none" />
                вам 1&nbsp;000&nbsp;баллов — это&nbsp;1&nbsp;000&nbsp;₽
              </div>
            </div>
            <Button
              className={styles.btn}
              onClick={() => handleClickBanner(buttonText, "Ваш друг рекомендует")}
            >
              {buttonText}
            </Button>
          </div>
        </Container>
      </section>
      <div className={clsx(styles.btnBlock, { [styles.hideMobBlock]: isVisible })}>
        <Container>
          <Button onClick={handleClickStickyBtn} className={styles.mobBtn}>
            {buttonText}
          </Button>
        </Container>
      </div>
    </>
  )
}
